import { Module } from 'vuex';
import { NavigationState } from './types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const navigation: Module<NavigationState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default navigation;
